import CommentContainer from './commentContainer';

export default CommentContainer;
